<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable" :pageData="pageData"></table-page>
    <UPDATE  ref="childUpdate"  @uploadResult="uploadResult"  :updateData="updateData"></UPDATE>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import UPDATE from '@/components/page/update.vue'
  import URL from '@/views/newmis36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
      UPDATE
    },
    methods: {
      uploadResult(col,res){
        this.$refs.childTable.defaultQueryData(this.queryData);
        if (res.code == 0){
          this.$refs.childUpdate.close();
        }else{
          this.$message.error(res.message);
        }
      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data){
        if("查询" == clickName){
          this.queryData = data;
          this.queryData.type = this.flag;
          this.$refs.childTable.defaultQueryData(this.queryData);
        }else if("上传" == clickName){
          this.$refs.childUpdate.open();
        }
      },
    },
    beforeMount() {
      let flag = DateUtil.getParamKey(this.$route.params);
      this.updateData.cols = [
        { title: "上传用户", field: 'file', option:{'type':flag},type:11,action:URL.tradingActivitiesCustomer.upload,downUrl:"https://static.chwenda.com/source/downloadModel/%E6%A6%9C%E5%8D%95%E6%B4%BB%E5%8A%A8%E7%94%A8%E6%88%B7%E4%BA%A4%E6%98%93%E9%87%8F.xlsx"},
      ]
    },
    data () {
      return {
        flag:DateUtil.getParamKey(this.$route.params),
        queryData:{},
        /*新增或更新*/
        updateData:{
          submit: "hidden",
          modelName:"上传用户",
          cols:[]
        },
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
            { title: '用户', field: 'customerNumber'},
            {click:"查询"},
            {click:"上传"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.tradingActivitiesCustomer.list, //请求路径和参数
          sequence: true,
          cols: [
            { title: '用户', field: 'customerNumber'},
            { title: '用户级别', field: 'level'},
            { title: '交易量', field: 'tradeCount'},
            { title: '创建时间', field: 'createTime',render:(data,full)=>{
                return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
              }},
          ]
        }
      }
    }
  }
</script>
